import React from 'react';
import { Navigate } from 'react-router-dom';

import { CuroAppRoute } from 'enums/curo/CuroAppRoute';
import { useCurrentStep } from 'hooks/useCurrentStep';

import { SignInProcessSteps } from './constants';
import PhoneNumberStep from './steps/PhoneNumberStep';
import VerifyCodeStep from './steps/VerifyCodeStep';

const SignInProcess = () => {
  const [currentStep, setCurrentStep] = useCurrentStep<SignInProcessSteps>(
    SignInProcessSteps.PhoneNumberStep,
  );

  const renderStep = () => {
    switch (currentStep) {
      case SignInProcessSteps.PhoneNumberStep:
        return (
          <PhoneNumberStep
            onStepComplete={() => setCurrentStep(SignInProcessSteps.VerificationCodeStep)}
          />
        );
      case SignInProcessSteps.VerificationCodeStep:
        return (
          <VerifyCodeStep
            onStepComplete={() => setCurrentStep(SignInProcessSteps.RedirectToResumeProcessStep)}
          />
        );
      case SignInProcessSteps.RedirectToResumeProcessStep:
        return <Navigate to={CuroAppRoute.ResumeProcess} />;
      default:
        return null as never;
    }
  };

  return renderStep();
};

export default SignInProcess;
